import React, { useEffect, useState } from "react";
import { fetchTransactions } from "../api.js";
import ChartDataLabels from "chartjs-plugin-datalabels";

import { Pie, Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  ArcElement,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  ArcElement,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
  ChartDataLabels
);

const MONTH_NAMES = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export default function AnalyticsPage() {
  const [items, setItems] = useState([]);

  const [selectedYear, setSelectedYear] = useState("");
  const [selectedMonth, setSelectedMonth] = useState("");

  useEffect(() => {
    fetchTransactions().then(setItems);
  }, []);

  // Extract all years
  const years = Array.from(
    new Set(items.map((t) => new Date(t.date).getFullYear()))
  ).sort();

  // Extract months for selected year
  const months = selectedYear
    ? Array.from(
        new Set(
          items
            .filter(
              (t) => new Date(t.date).getFullYear() === Number(selectedYear)
            )
            .map((t) => new Date(t.date).getMonth())
        )
      ).sort((a, b) => a - b)
    : [];

  // Filter data
  const filtered = items.filter((t) => {
    const d = new Date(t.date);
    const y = d.getFullYear();
    const m = d.getMonth() + 1;

    if (selectedYear && y !== Number(selectedYear)) return false;
    if (selectedMonth && m !== Number(selectedMonth)) return false;
    return true;
  });

  // Totals for pie chart
  const totalIn = filtered
    .filter((t) => t.type === "in")
    .reduce((sum, t) => sum + t.amount, 0);

  const totalOut = filtered
    .filter((t) => t.type === "out")
    .reduce((sum, t) => sum + t.amount, 0);

  // Weekly totals for bar chart
  function getWeekNumber(date) {
    const d = new Date(date);
    return Math.ceil(d.getDate() / 7);
  }

  const weeklyTotals = [0, 0, 0, 0, 0]; // Week 1–5

  filtered.forEach((t) => {
    if (selectedMonth) {
      const week = getWeekNumber(t.date);
      weeklyTotals[week - 1] += t.amount;
    }
  });

  // Pie chart data
  const pieData = {
    labels: ["In", "Out"],
    datasets: [
      {
        data: [totalIn, totalOut],
        backgroundColor: ["#4CAF50", "#F44336"],
      },
    ],
  };

  // Bar chart data
  const barData = {
    labels: ["Week 1", "Week 2", "Week 3", "Week 4", "Week 5"],
    datasets: [
      {
        label: "Weekly Total",
        data: weeklyTotals,
        backgroundColor: "#2196F3",
      },
    ],
  };

  //bar chart options with value on top
  const barOptions = {
    plugins: {
      datalabels: {
        anchor: "end",
        align: "top",
        color: "#000",
        font: {
          weight: "bold",
          size: 12,
        },
        formatter: (value) => value,
      },
    },
    scales: {
      y: {
        beginAtZero: true,
      },
    },
  };

  return (
    <div>
      <h2>Analytics Dashboard</h2>

      {/* YEAR DROPDOWN */}
      <div>
        <label>Select Year: </label>
        <select
          value={selectedYear}
          onChange={(e) => {
            setSelectedYear(e.target.value);
            setSelectedMonth("");
          }}
        >
          <option value="">-- All Years --</option>
          {years.map((y) => (
            <option key={y} value={y}>
              {y}
            </option>
          ))}
        </select>
      </div>

      {/* MONTH DROPDOWN */}
      {selectedYear && (
        <div>
          <label>Select Month: </label>
          <select
            value={selectedMonth}
            onChange={(e) => setSelectedMonth(e.target.value)}
          >
            <option value="">-- All Months --</option>
            {months.map((m) => (
              <option key={m} value={m + 1}>
                {MONTH_NAMES[m]}
              </option>
            ))}
          </select>
        </div>
      )}

      <hr />

      {/* PIE CHART */}
      <h3>In vs Out</h3>
      <Pie data={pieData} width={50} height={50} />

      <hr />

      {/* BAR CHART */}
      {selectedMonth ? (
        <>
          <h3>Weekly Totals</h3>
          <Bar data={barData} width={50} height={50} />
          <Bar data={barData} options={barOptions} width={50} height={50} />
        </>
      ) : (
        <p>Select a month to see weekly totals</p>
      )}
    </div>
  );
}
